import './spacing.scss';

const layerMap = {
    m: 'margin',
    p: 'padding',
    g: 'gap',
};
const dirMap = {
    t: 'top',
    b: 'bottom',
    l: 'left',
    r: 'right',
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    x: 'x',
    y: 'y',
    all: 'all',
};
const gapDirMap = {
    all: 'all',
    row: 'row',
    column: 'column',
    x: 'column',
    y: 'row',
};
function toSpacingAttributes(layer, values) {
    if (values === undefined || values === null)
        return {};
    const attrs = {};
    const setAttr = (side, spacing) => {
        attrs[`data-rev-spacing-${layerMap[layer]}-${side}`] = `${spacing}`;
    };
    if (typeof values === 'string' || typeof values === 'number') {
        setAttr('all', values);
        return attrs;
    }
    // Handle gap layer with different direction keys
    if (layer === 'g') {
        const gapValues = values;
        for (const key in gapValues) {
            const dir = gapDirMap[key];
            const spacing = gapValues[key];
            if (!dir || spacing === undefined || spacing === null)
                continue;
            switch (dir) {
                case 'all':
                    setAttr('all', spacing);
                    break;
                case 'row':
                    setAttr('row', spacing);
                    break;
                case 'column':
                    setAttr('column', spacing);
                    break;
                case 'x':
                    setAttr('column', spacing);
                    break;
                case 'y':
                    setAttr('row', spacing);
                    break;
            }
        }
    }
    else {
        // Handle margin/padding layers with standard direction keys
        const spacingValues = values;
        for (const key in spacingValues) {
            const dir = dirMap[key];
            const spacing = spacingValues[key];
            if (!dir || spacing === undefined || spacing === null)
                continue;
            switch (dir) {
                case 'top':
                    setAttr('top', spacing);
                    break;
                case 'bottom':
                    setAttr('bottom', spacing);
                    break;
                case 'left':
                    setAttr('left', spacing);
                    break;
                case 'right':
                    setAttr('right', spacing);
                    break;
                case 'x':
                    setAttr('x', spacing);
                    break;
                case 'y':
                    setAttr('y', spacing);
                    break;
                case 'all':
                    setAttr('all', spacing);
                    break;
            }
        }
    }
    return attrs;
}

export { toSpacingAttributes };
//# sourceMappingURL=spacing.js.map
